import React, { type FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'
import { type OrderType } from 'legacy/sections/orders/utils/orders.types'
import { Breadcrumbs, Breadcrumb } from 'legacy/components/Breadcrumbs'
import { OrdersBreadcrumbsOrderType } from 'legacy/sections/orders/components/breadcrumbs/components/OrdersBreadcrumbsOrderType'

interface Props {
  orderType?: OrderType
}

export const OrdersBreadcrumbs: FunctionComponent<Props> = ({ orderType }) => (
  <Breadcrumbs>
    <Breadcrumb>
      <FormattedMessage id="orders.title" />
    </Breadcrumb>
    {orderType && <OrdersBreadcrumbsOrderType orderType={orderType} />}
  </Breadcrumbs>
)
